<template>
  <v-col :cols="cols">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scroll-x-transition"
      offset-x
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-sheet
          :color="color"
          rounded
          elevation="3"
          :height="25"
          :width="25"
          v-bind="attrs"
          v-on="on"
        ></v-sheet>
      </template>
      <v-color-picker 
        v-model="color"
        :mode="mode"
        @input="updateColor"
        hide-mode-switch
        :disabled="disabled"
      ></v-color-picker>
    </v-menu>
  </v-col>
</template>

<script>
export default {
  name: "DataPickerComponent",
  props: {
    value: String, // v-model binding
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'hexa',
    },
    cols: {
      type: Number,
      default: 2,
    },
    height: {
      type: String,
      default: '25',
    },
    width: {
      type: String,
      default: '25',
    },
  },
  data() {
    return {
      menu: false,
      color: this.value || '', // bind date to the value prop
    };
  },
  watch: {
    value(newVal) {
      this.color = newVal || ''; // update date when value prop changes
    }
  },
  methods: {
    updateColor(val) {
      this.color = val;
      this.$emit('input', this.color); // emit the new date to parent component
    },
  },
};
</script>
